import React from 'react';
import { motion } from 'framer-motion';
import { IconWrapper } from './IconWrapper';
import { 
  HiExclamationCircle,
  HiArrowPath
} from 'react-icons/hi2';

interface ErrorStateProps {
  title: string;
  message: string;
  error?: Error;
  onRetry?: () => void;
  fullScreen?: boolean;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  message,
  error,
  onRetry,
  fullScreen = false
}) => {
  const containerClasses = fullScreen
    ? 'fixed inset-0 z-50 bg-white dark:bg-gray-900'
    : 'w-full min-h-[400px]';

  return (
    <div className={containerClasses}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col items-center justify-center h-full p-6 text-center"
      >
        <IconWrapper icon={HiExclamationCircle} className="w-16 h-16 text-red-500 mb-4" />
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
          {message}
        </p>

        {error && process.env.NODE_ENV === 'development' && (
          <pre className="mt-4 p-4 bg-gray-100 dark:bg-gray-800 rounded-lg text-left overflow-auto max-w-full text-sm text-gray-700 dark:text-gray-300">
            {error.message}
            {error.stack && (
              <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                {error.stack}
              </div>
            )}
          </pre>
        )}

        {onRetry && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onRetry}
            className="btn-primary"
          >
            <IconWrapper icon={HiArrowPath} className="w-5 h-5 mr-2" />
            Try Again
          </motion.button>
        )}
      </motion.div>
    </div>
  );
};